//  Analytics tracking functions
const googleAnalytics4AddItemToBasket = (id, totalCost, ticketsQuantity) => {
  if (
    // process.env.NODE_ENV === 'production' &&
    typeof window.gtag === 'function'
  ) {
    window.gtag('event', 'AddItemToBasketFromWinRaffle', {
      category: 'ecommerce',
      action: 'click',
      id: id,
      currency: 'GBP',
      affiliation: 'Raffle House',
      quantity: ticketsQuantity,
      price: totalCost,
      value: totalCost,
    });
  }
};

export { googleAnalytics4AddItemToBasket };
